export const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
